import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

/**
 * Page / section title. Use standalone or after one or more Breadcrumb components.
 *
 * @param {React.ReactNode} props.children   - Title text
 * @param {string}          [props.className]
 */
const HeaderTitle = ({ children, className }) => {
  const classes = useStyles();

  return (
    <h1 className={clsx(classes.root, className)}>{children}</h1>
  );
};

export default HeaderTitle;

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: "Lato, sans-serif",
    fontSize: "24px",
    fontWeight: "normal",
    lineHeight: "normal",
    color: "var(--color-text-primary)",
    margin: "0",
    padding: "0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));
